import type { HtmlVisual, InsightDocument, VisualPayload } from './types';

// Narrow a visual payload to the HTML format (the active Visualizer output).
export const isHtmlVisual = (visual?: VisualPayload | null): visual is HtmlVisual =>
  !!visual &&
  (visual as HtmlVisual).format === 'html' &&
  typeof (visual as HtmlVisual).html === 'string';

// The chat renders the visual only when it actually has content; otherwise it
// falls back to the markdown answer. Handles both the HTML visual (current) and
// legacy component documents (older persisted messages). Pure so the render
// decision is unit-testable without mounting the chat screen.
export const hasRenderableVisual = (visual?: VisualPayload | null): boolean => {
  if (!visual) return false;
  if (isHtmlVisual(visual)) return visual.html.trim().length > 0;
  const doc = visual as InsightDocument;
  return Array.isArray(doc.sections) && doc.sections.length > 0;
};
